var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('span',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("action")],2),_c('div',{staticClass:"card-content"},[_c('Loading',{attrs:{"show":_vm.loading}}),_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }